import * as actions from "../action.constants";

const initialState = {
  isLoading: false,
  simModalStatus: false,
  simModalData: {},
  sims_data: {},
};

const simsReceived = (state, action) => {
  return {
    ...state,
    sims_data: action.responsePayload,
  };
};
const addSimModalStatus = (state, action) => {
  return {
    ...state,
    simModalStatus: action.payload,
  };
};

const addSimModalData = (state, action) => {
  return {
    ...state,
    simModalData: action.payload,
  };
};

const simUsageDetails = (state, action) => {
  return {
    ...state,
    simUsageDetails: action.payload,
  };
};

const handlers = {
  [actions.SAVE_ADD_SIM_MODAL_STATUS]: addSimModalStatus,
  [actions.SAVE_ADD_SIM_MODAL_DATA]: addSimModalData,
  [actions.SAVE_SIMS_LIST]: simsReceived,
  [actions.SAVE_SIM_USAGE_DETAILS]: simUsageDetails,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
